import BaseObject from '../../../base/base_object';
import NoRestrictionValue from '../values/no_restriction_value';
import { IRestrictionValueFactory, RestrictionValueFactory } from './value_factory';
import ServiceFactory from '../../service_factory';
import IRestrictionValueBase from '../values/restriction_value_base_interface';
import IRestrictionsPool, { IRestrictionsMap } from './restrictions_pool_interface';

const RESTRICTION_ENTITY_TYPE = {
  SUB_BRAND: '1',
  GAME_TYPE: '2',
  PACKAGE: '3',
  GAME_GROUP: '8'
};

export default class RestrictionsPool extends BaseObject implements IRestrictionsPool {
  static CLASS = 'RestrictionsPool';
  private _serviceFactory: ServiceFactory;
  private _restrictionValueFactory: IRestrictionValueFactory;
  private _currentPackageId: string;
  private _currentSubBrandId: string;
  private _noRestriction: IRestrictionValueBase;
  private _restrictionsMap: IRestrictionsMap;

  init(params) {
    super.init(params);
    this._serviceFactory = params.serviceFactory;
    this._restrictionValueFactory = params.restrictionValueFactory || RestrictionValueFactory.create({
      serviceFactory: params.serviceFactory
    });

    this._currentPackageId = this._serviceFactory.skinService().getProductPackageID().toString();
    this._currentSubBrandId = this._serviceFactory.skinService().getSubBrandID().toString();

    this._noRestriction = NoRestrictionValue.create();
    this._loadRestrictions(params.restrictionsByAction);
  }

  public getGameRestriction(gameType: number, gameGroupId: number): any {
    const restriction = this._getFirstNonExpiredRestriction(this._restrictionsMap.gameGroups[gameGroupId],
      this._restrictionsMap.gameTypes[gameType],
      this._restrictionsMap.allGameTypes,
      this._restrictionsMap.currentSubBrand,
      this._restrictionsMap.currentPackage);

    return restriction;
  }

  public isPackageRestrictedForOpen(): boolean {
    for(let i = 0; i < this._restrictionsMap.currentPackage.length; i++) {
      const packageRestriction = this._restrictionsMap.currentPackage[i];
      if(packageRestriction.isActiveRestrictionForOpenApplication()) {
        return true;
      }
    }
    return false;
  }

  public isSubBrandRestrictedForOpen(): boolean {
    for(let i = 0; i < this._restrictionsMap.currentSubBrand.length; i++) {
      const subBrandRestriction = this._restrictionsMap.currentSubBrand[i];
      if(subBrandRestriction.isActiveRestrictionForOpenApplication()) {
        return true;
      }
    }
    return false;
  }

  private _getFirstNonExpiredRestriction(...restrictionSections: any[]): any {
    for(let i = 0; i < restrictionSections.length; i++) {
      const section = restrictionSections[i];
      if(section) {
        for(let j = 0; j < section.length; j++) {
          const restrictionValue = section[j];
          if(!restrictionValue.isExpired()) {
            return restrictionValue;
          }
        }
      }
    }

    return this._noRestriction;
  }


  private _createRestrictionValue(actionId: any, restrictionData: any): IRestrictionValueBase {
    return this._restrictionValueFactory.createRestrictionValue(actionId, restrictionData);
  }


  private _loadRestrictions(restrictionsByAction: any[]): void {

    const restrictionsMap = this._initRestrictionsMap();

    if(restrictionsByAction) {
      restrictionsByAction.forEach(restrictionByAction => {
        restrictionByAction.Entities.forEach(restrictionEntity => {
          this._appendRestrictionEntityValues(restrictionsMap, restrictionByAction.ActionId, restrictionEntity);
        });
      });
    }

    this._restrictionsMap = restrictionsMap;
  }

  private _initRestrictionsMap(): IRestrictionsMap {
    return {
      gameTypes: {
      },
      gameGroups: {

      },
      allGameTypes: [],
      currentPackage: [],
      currentSubBrand: []
    };
  }


  private _appendRestrictionEntityValues(restrictionsMap: IRestrictionsMap, actionId: any, restrictionEntity: any): void {
    try {
      if (!(restrictionEntity && restrictionEntity.Values && restrictionEntity.EntityId)) {
        return;
      }

      switch (restrictionEntity.EntityId.toString()) {

        case RESTRICTION_ENTITY_TYPE.GAME_GROUP:
          restrictionEntity.Values.forEach(restrictionValue => {
            const gameGroupRestrictions = this._initRestrictionsMapSection(restrictionsMap, 'gameGroups',restrictionValue.Value);
            gameGroupRestrictions.push(this._createRestrictionValue(actionId, restrictionValue));
          });
          break;

        case RESTRICTION_ENTITY_TYPE.GAME_TYPE:
          restrictionEntity.Values.forEach(restrictionValue => {
            if(restrictionValue.Value.toLowerCase() === 'all') {
              const allGameTypesRestrictions = this._initRestrictionsMapSection(restrictionsMap, 'allGameTypes');
              allGameTypesRestrictions.push(this._createRestrictionValue(actionId, restrictionValue));
            } else {
              const gameTypeRestrictions = this._initRestrictionsMapSection(restrictionsMap, 'gameTypes', restrictionValue.Value);
              gameTypeRestrictions.push(this._createRestrictionValue(actionId, restrictionValue));
            }

          });
          break;

        case RESTRICTION_ENTITY_TYPE.PACKAGE:
          restrictionEntity.Values.forEach(restrictionValue => {
            if(restrictionValue.Value.toString() === this._currentPackageId) {
              const currentPackageRestrictions = this._initRestrictionsMapSection(restrictionsMap, 'currentPackage');
              currentPackageRestrictions.push(this._createRestrictionValue(actionId, restrictionValue));
            }
          });
          break;

        case RESTRICTION_ENTITY_TYPE.SUB_BRAND:
          restrictionEntity.Values.forEach(restrictionValue => {
            if(restrictionValue.Value.toString() === this._currentSubBrandId) {
              const currentSubBrandRestrictions = this._initRestrictionsMapSection(restrictionsMap, 'currentSubBrand');
              currentSubBrandRestrictions.push(this._createRestrictionValue(actionId, restrictionValue));
            }
          });
          break;

        case '9':
          this.logger.debug( `restriction entity 9 (GameVendor)  is ignore by Orbit, behind the scenes Platform are converting it to restriction on play/open application for all the relevant game type`);
          //in the future they should remove the duplication so we'll not get the entity 9 (GameVendor) at all
          break;

        case '10':
          this.logger.debug( `restriction entity 10 (childish games)  is ignore by Orbit, behind the scenes Platform are converting it to restriction on play/open application for all the relevant game type`);
          //in the future they should remove the duplication so we'll not get the entity 9 (GameVendor) at all
          break;
        default:
          this.logger.error('175', ` restriction entity id ${restrictionEntity.EntityId} is not supported`);

      }
    } catch(err) {
      this.logger.error('179', `Can't handle restriction due to Error: ${err}`);
    }
  }

  private _initRestrictionsMapSection(restrictionsMap: IRestrictionsMap, sectionName: string, value?: any) {
    let section = null;
    if(value) {
      section = restrictionsMap[sectionName][value];
    } else {
      section = restrictionsMap[sectionName];
    }
    if(!section) {
      section = [];
      if(value) {
        restrictionsMap[sectionName][value] = section;
      } else {
        restrictionsMap[sectionName] = section;
      }
    }
    return section;
  }
}

